import React from "react";

import useTranslations from "../../hooks/useTranslations";

import { ReviewType } from "../../screens/ReviewListScreen";
import { Link } from "../wombat-ui";

import UserAvatarGroup from "../utils/UserAvatarGroup";
import { Tag } from "@chakra-ui/react";
import { ReviewFragment } from "../../graphql/generated/definitions";

function getTagColorByStatus(status: ReviewType): string {
  if (status === "next") return "yellow";
  if (status === "ongoing") return "blue";
  if (status === "finished") return "gray";
  if (status === "available") return "green";
}

type FollowUpCardProps = {
  review: ReviewFragment;
  reviewType: ReviewType;
  isCollaboratorViewing?: boolean;
};

const FollowUpCard: React.FC<FollowUpCardProps> = ({
  review,
  reviewType,
  isCollaboratorViewing = false,
}) => {
  const t = useTranslations();

  return (
    <li className="py-4 list-none" id={`followUpCard_${review.id}`}>
      <div className="grid items-center justify-between grid-cols-5">
        <div className="flex items-center col-span-3">
          <Link
            to={`/reviews/${review.id}`}
            id={`${review.id}-link`}
            className="text-sm font-medium truncate"
          >
            {review?.template?.title && `${review.template.title} - `}
            {review.collaborator.name}
          </Link>
        </div>
        <div>
          <p className="pb-0.5 text-xs font-medium text-light-900">
            {t("reviews.referent", { count: review.referents.length })}
          </p>
          {review.referents.length > 0 ? (
            <UserAvatarGroup users={review.referents} max={4} />
          ) : (
            <p className="text-xs font-medium text-light-900">
              {t("reviews.noReferent")}
            </p>
          )}
        </div>
        <div className="flex items-center justify-end">
          <div className="flex-shrink-0 hidden gap-1 lg:flex">
            <Tag colorScheme={getTagColorByStatus(reviewType)}>
              {t(`reviews.status.${reviewType}` as const, { count: 1 })}
            </Tag>
          </div>
        </div>
      </div>
    </li>
  );
};

export default React.memo(FollowUpCard);
